import React from 'react';
import styled from 'styled-components';
import { Controller, Scene } from 'react-scrollmagic';
import { Tween, Timeline } from 'react-gsap';
import { useStaticQuery, graphql } from "gatsby"
import { Flex, Box, Text, Link } from 'rebass'
import Img from "gatsby-image"
import Twitter from './svgs/twitter';

const Sticky2Styled = styled.div`
  overflow-x: hidden;
  .section {
    height: 70vh;
    background: linear-gradient(160deg, #f47c66 0%,#e51906 100%);
  }
  a {
    color: inherit; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
  }

  .sticky, .sticky2 {
    height: 100vh;
    width: 100%;
    & .animation, .animation2 {
      width: 100%;
      height: 100%;
      position: absolute;
      & .gatsby-image-wrapper {
        opacity: 1;
        position: absolute;
        padding: 0;
      }
    }
    .heading {
      position: absolute;
      height: 100%;
      width: 100%;
      h2 {
        font-size: 40px;
        position: absolute;
        bottom: 10%;
        left: 10%;
        margin: 0;
      }
    }
  }
`;

const Intro = () => {
  const data = useStaticQuery(graphql`
    query {
      santa: file(relativePath: { eq: "santa.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf1: file(relativePath: { eq: "elf1.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf2: file(relativePath: { eq: "elf2.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf3: file(relativePath: { eq: "elf3.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf4: file(relativePath: { eq: "elf4.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf7: file(relativePath: { eq: "elf7.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf8: file(relativePath: { eq: "elf8.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf9: file(relativePath: { eq: "elf9.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf12: file(relativePath: { eq: "elf12.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf13: file(relativePath: { eq: "elf13.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      elf16: file(relativePath: { eq: "elf16.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      kent: file(relativePath: { eq: "kent.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      minty: file(relativePath: { eq: "mintycandycane.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      krampus1: file(relativePath: { eq: "krampus1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      me: file(relativePath: { eq: "me.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      fairy: file(relativePath: { eq: "fairy.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }
  `)

  return (

    <Sticky2Styled>
      <div id='san' />
      <Controller>

        <Scene
          triggerHook="onLeave"
          duration={3200}
          pin
        >
          {(progress) => (
            <div className="sticky">

            <Flex color='#CBCFD4' textAlign='center' pt={[2]} flexDirection='row'>
              <Box width={['20vw', '0vw']}/>
              <Flex width={['80vw', '100vw']} flexDirection='column'>
                <h1>2019 Holiday Hack Challenge</h1>
                <h2> write-up by Nikki Jack</h2>
                <Flex fontSize={3} height='5vh' justifyContent='center'>
                  <Link href='https://twitter.com/DEVintheCITY' target="_blank">
                  <Flex justifyContent='center' alignItems='center'>
                    <Twitter />
                    <Text ml={2}>DEVintheCITY</Text>
                  </Flex>
                  </Link>
                </Flex>
              </Flex>
            </Flex>


              <Timeline totalProgress={progress} paused>
                <Tween
                  from={{ opacity: 1 }}
                  to={{ opacity: 0 }}
                >
                  <div className="animation">
                  <Flex flexDirection='row'>
                    <Box width={['20vw', '0vw']}/>
                    <Flex
                        fontFamily='Roboto'
                        fontSize={2}
                        fontWeight='300'
                        pt={3}
                        width={'80vw', '100vw'}
                        color='#CBCFD4'
                        justifyContent='center'
                        alignItems='center'
                        flexDirection='column'
                      >
                       <Flex flexDirection={['column', 'row']}>
                        <Text mr={2}>click buttons on top left to navigate</Text>
                        <Text>between objectives and terminals</Text>
                        </Flex>
                        <Text><b>OR</b></Text>
                        <Text>keep scrolling</Text>
                      </Flex>
                    </Flex>
                  </div>
                </Tween>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.santa.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '40vh', width: '20vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '42%', top: '100%'}}
                    to={{ x: '42%', top: '54%' }}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.kent.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '-30%', top: '32%'}}
                    to={{ x: '45%', top: '32%' }}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf1.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '110%', top: '32%'}}
                    to={{ x: '49%', top: '32%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.minty.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '-30%', top: '34%'}}
                    to={{ x: '41%', top: '34%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf2.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '110%', top: '34%'}}
                    to={{ x: '53%', top: '34%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf3.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '-30%', top: '36%'}}
                    to={{ x: '37%', top: '36%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf4.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '110%', top: '36%'}}
                    to={{ x: '57%', top: '36%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf7.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '-30%', top: '38%'}}
                    to={{ x: '33%', top: '38%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf8.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '110%', top: '38%'}}
                    to={{ x: '61%', top: '38%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf9.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '-30%', top: '40%'}}
                    to={{ x: '29%', top: '40%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf12.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '110%', top: '40%'}}
                    to={{ x: '65%', top: '40%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf13.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '-30%', top: '42%'}}
                    to={{ x: '25%', top: '42%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>

                <Timeline
                  target={
                    <div className="animation">
                      <Img
                       fluid={data.elf16.childImageSharp.fluid}
                       style={{ margin: 0,  maxHeight: '30vh', maxWidth: '10vw' }}
                       imgStyle={{ objectFit: 'contain' }}

                      />
                    </div>
                  }
                >
                  <Tween
                    from={{ x: '110%', top: '42%'}}
                    to={{ x: '69%', top: '42%'}}
                    ease='Back.easeIn'
                  />
                </Timeline>



              </Timeline>
            </div>
          )}
        </Scene>

        <Scene duration={700} pin triggerHook="0.3">
        <Timeline
              target={
                <div className="animation">
                <Flex textAlign='center' color='#CBCFD4' height="100vh" flexDirection='column'>
                  <h1> TL;DR</h1>
                  <Text>The Tooth Fairy is jealous of Santa's team and resources and tries to ruin Christmas. </Text>
                  <Text>We team up with Krampus to save the holidays</Text>
                  <Flex height="50vh" flexDirection='row' justifyContent='center'>
                  <Box>
                    <Img
                     fluid={data.fairy.childImageSharp.fluid}
                     style={{ margin: 0,  maxHeight: '30vh', width: '10vw' }}
                     imgStyle={{ objectFit: 'contain' }}

                    />
                    </Box>
                    <Box>
                    <Img
                     fluid={data.me.childImageSharp.fluid}
                     style={{ margin: 0,  maxHeight: '30vh', width: '10vw' }}
                     imgStyle={{ objectFit: 'contain' }}

                    />
                    </Box>
                    <Box>
                    <Img
                     fluid={data.krampus1.childImageSharp.fluid}
                     style={{ margin: 0,  maxHeight: '30vh', width: '10vw' }}
                     imgStyle={{ objectFit: 'contain' }}

                    />
                    </Box>
                  </Flex>
                </Flex>
                </div>
              }
            >
              <Tween
                from={{ opacity: 0 }}
                to={{ opacity: 1 }}
              />
              <Tween
                to={{ opacity: 0 }}
              />
          </Timeline>


        </Scene>

      </Controller>
    </Sticky2Styled>

  );
}

export default Intro;
